/* eslint react-hooks/exhaustive-deps: "warn" */

import { Button } from 'ui/atoms/Button/Button';

import { CrmEnrichDemo } from 'features/crm/organisms/CrmEnrichDemo/CrmEnrichDemo';

import styles from './CrmHero.module.scss';

import type { CrmHeroProps } from './CrmHero.types';

export const CrmHero = ({ eyebrow, title, description, record }: CrmHeroProps) => (
  <header className={styles.hero}>
    <div className={styles.inner}>
      <div className={styles.copy}>
        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}

        <h1 className={styles.title}>{title}</h1>

        <p className={styles.lede}>{description}</p>

        <div className={styles.actions}>
          <Button type="blue" size="xxl" href="#integrations" suffix={<span className={styles.arr}>→</span>}>
            See the integrations
          </Button>

          <a className={styles.scroll} href="#fields">
            What lands in your fields
          </a>
        </div>
      </div>

      <CrmEnrichDemo record={record} className={styles.demo} />
    </div>
  </header>
);
